import api, { ApiInputs, ApiResponses } from 'lib/trpcClient';
import { mapResponseToCapitalActionNoticeCreatorData } from './mapping';
import { getQueryKey } from '@trpc/react-query';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';

type Input = {
  capitalActionId: string;
  vehicleId: string;
};

export const useCapitalActionNotice = ({
  capitalActionId,
  vehicleId,
}: Input) => {
  const [data] = api.capitalActionNotice.get.useSuspenseQuery({
    capitalActionId,
    vehicleId,
  });

  const queryKey = getQueryKey(api.capitalActionNotice.get, {
    capitalActionId,
    vehicleId,
  });

  const { mutate: save, ...saveMutation } =
    api.capitalActionNotice.update.useMutation(
      useHandleTrpcMutation<
        ApiResponses['capitalActionNotice']['update'],
        ApiInputs['capitalActionNotice']['update']
      >()({
        invalidations: [queryKey],
      }),
    );

  const { mutate: publish, ...publishMutation } =
    api.capitalActionNotice.publish.useMutation(
      useHandleTrpcMutation<
        ApiResponses['capitalActionNotice']['update'],
        ApiInputs['capitalActionNotice']['update']
      >()({
        invalidations: [queryKey],
      }),
    );

  return {
    data: mapResponseToCapitalActionNoticeCreatorData(data),
    saving: saveMutation.isPending || publishMutation.isPending,
    save,
    publish,
  };
};
